import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const modal = css`
  max-inline-size: ${spacing(96)};
`
export const drawer = css`
  padding-inline: 0;
`
